import { versionHelper } from '@xerius/codey-utils-vue2';
import packageJson from '@/../package';

/**
 *
 * @param {String} pictogramNaam
 * @param {String} folder = 'pictograms'
 * @returns {String}
 */
export default function (pictogramName, folder = 'pictograms') {
  return `https://cdn.xerius.be/vue2/style/${versionHelper.getVersion(
    packageJson,
    '@xerius/codey-style-vue2'
  )}/assets/images/${folder}/${pictogramName}.svg`;
}
